import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
    ul: {
        justifyContent: 'space-around'
    }
}));